import logger from "@/lib/logger";
import newrelic from "@/lib/monitoring/newrelic";
import {
  MonarchPayload,
  MonarchHeaders,
  MonarchApiServerResponse,
} from "./types";
import { monarch } from "@redventures/cohesion-utils-react";
import { MONARCH_SOURCE_ID } from "./constants";
import getDapiRandomId from "@/lib/dapi/utils/getDapiRandomId";

// Client-side monarch config - static values only
const monarchConfig = {
  sourceId: MONARCH_SOURCE_ID,
};

/**
 * Client-side Monarch API function using cohesion-utils
 * Use this for browser-side evaluations
 */
const monarchApiClient = (
  ruleId: string,
  payload: MonarchPayload,
): Promise<MonarchApiServerResponse> =>
  new Promise((resolve, reject) => {
    monarch(
      "rule",
      ruleId,
      payload,
      { sourceId: monarchConfig.sourceId },
      (err, result) => {
        if (err) reject(err);
        else resolve(result);
      },
    );
  });

/**
 * Client-side Monarch API function for browser evaluations
 * This function uses the cohesion-utils-react library
 */
export async function callMonarchApi(
  ruleId: string,
  payload: MonarchPayload,
): Promise<MonarchApiServerResponse | null> {
  try {
    const dapiRandomId = getDapiRandomId();
    const expandedPayload = {
      ...payload,
      ...(dapiRandomId && { dapiRandomId }),
    };

    return await monarchApiClient(ruleId, expandedPayload);
  } catch (error) {
    logger.error(`Error calling Monarch API:`, error);
    newrelic.noticeError(error as Error, {
      message: "Error calling Monarch API",
    });
    return null;
  }
}
